import { ChevronDownIcon, ChevronUpIcon } from '@rsos/assets/icons';
import Loader from '@rsos/base-components/Loader';
import { type PaginatedConversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import ConversationRow from './ConversationRow';
import styles from './ConversationTable.module.scss';

interface ConversationTableProps {
  displayList: PaginatedConversation[];
  isSortReversed: boolean;
  onSort: () => void;
  checkedList: Set<string>;
  isSelectedAllChecked: boolean;
  onToggleSelectAll: () => void;
  onCheck: (id: string) => void;
  onDownload: (ids: string[]) => void;
  isDownloading: boolean;
  isLoading?: boolean;
  isError?: boolean;
}

const ConversationTable = ({
  displayList,
  isSortReversed,
  onSort,
  checkedList,
  isSelectedAllChecked,
  onToggleSelectAll,
  onCheck,
  onDownload,
  isDownloading,
  isLoading = false,
  isError = false,
}: ConversationTableProps) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table} data-name="conversation-table">
        <thead>
          <tr>
            <th className={styles.th}>
              <input
                type="checkbox"
                data-name="conversation-select-all"
                checked={isSelectedAllChecked}
                onChange={onToggleSelectAll}
              />
            </th>
            <th className={styles.th}>PHONE NUMBER</th>
            <th className={`${styles.th} ${styles.sortable}`} onClick={onSort}>
              START TIME
              <span className={styles.sortIcon}>
                {isSortReversed ? (
                  <ChevronUpIcon width={12} height={12} />
                ) : (
                  <ChevronDownIcon width={12} height={12} />
                )}
              </span>
            </th>
            <th className={styles.th}>DURATION</th>
            <th className={styles.th}>TYPE</th>
            <th className={styles.th}>STATUS</th>
            <th className={styles.th} />
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={7}>
                <Loader
                  text="Loading conversations..."
                  dataName="conversation-loading"
                  fluid
                />
              </td>
            </tr>
          ) : isError ? (
            <tr>
              <td colSpan={7} className={`${styles.emptyRow} ${styles.danger}`}>
                Failed to load conversations.
              </td>
            </tr>
          ) : (
            <>
              {displayList.map(d => (
                <ConversationRow
                  key={d.conversation_id}
                  conversation={d}
                  isChecked={checkedList.has(d.conversation_id)}
                  onCheck={onCheck}
                  onDownload={onDownload}
                  isDownloading={isDownloading}
                />
              ))}
              {displayList.length === 0 && (
                <tr>
                  <td
                    colSpan={7}
                    className={styles.emptyRow}
                    data-name="conversation-empty-state"
                  >
                    No conversations found.
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ConversationTable;
